import { compose, branch, renderComponent } from 'recompose';
import { connect } from 'react-redux';
import PaidLandingPage from '../PaidLandingPage/PaidLandingPage';
import MarketingLandingPage from './MarketingLandingPage';
import { getPaidLandingPage } from 'store/modules/pages';

const enhance = compose(
	connect(
		(state, props) => {
			// only flips for the a/b test variation sf_15731_plp_refactor_ssdc
			const isPaidLandingVariation =
				state.experiments?.bucket?.sf_15731_plp_refactor_ssdc ==
				'variation';

			return {
				isPaidLanding: isPaidLandingVariation,
				queryParams: props.location // used to get utm_term and utm_source
					? Object.fromEntries(
							new URLSearchParams(props.location.search),
						)
					: {},
			};
		},
		{ getPaidLandingPage },
	),
	branch(
		(props) => props.isPaidLanding,
		compose(renderComponent(PaidLandingPage)), // renders the new PaidLandingPage on a/b
	),
);

export default enhance(MarketingLandingPage);
